const defaultState = {};

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_COMPANY_INFO':
      return action.companyInfo;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/companyInfo.js